<template>
	<div class="answerType">
		<!-- 응답내장형 입력 -->
		<div v-if="data.type === 'INPUT'" class="mgt-24">
			<label
					class="mdc-text-field mdc-text-field--outlined mdc-text-field--with-trailing-icon w-full customize-input h-46 "
					data-mdc-auto-init="MDCTextField">
					<span class="mdc-notched-outline">
									<span class="mdc-notched-outline__leading"></span>
									<span class="mdc-notched-outline__notch">
													<span id="my-label-id" class="mdc-floating-label">{{$t('1256')}}</span>
									</span>
									<span class="mdc-notched-outline__trailing"></span>
					</span>
					<input 
						autocomplete="off"
						class="mdc-text-field__input t-body6 font-r cursor-blue"
						maxlength="50"
						type="text"
						@keyup="answerType"
						@input="updateText"
						:value="text"
					/>
					<i class="material-icons mdc-text-field__icon mdc-text-field__icon--trailing" role="button"
									tabindex="0">report_problem</i>
			</label>
		</div>
		<!-- 응답내장형 선택 -->
		<div v-if="data.type === 'SELECT'" class="mgt-24">
				<div class="mdc-select mdc-select--outlined w-full mdc--select__custom"
							data-mdc-auto-init="MDCSelect">
						<div aria-labelledby="outlined-select-label" class="mdc-select__anchor h-46">
							<span class="mdc-notched-outline">
											<span class="mdc-notched-outline__leading"></span>
											<span class="mdc-notched-outline__notch">
															<span id="outlined-select-label"
																			class="mdc-floating-label t-body6 t-color-textfieldGuid font-r">	{{$t('1255')}}</span>
											</span>
											<span class="mdc-notched-outline__trailing"></span>
							</span>
							<!-- <select class="mdc-select__native-control mdc-select--outlined w-full mgt-8 mgr-8"
									v-model="text" @keyup="answerType"> -->

							<select v-model="text"
									class="mdc-select__native-control mdc-select--outlined w-full mgt-8 mgr-8 bg-transparent">
									<option  value=""> </option>
									<option v-for="(view, index) in data.views" :key="index" :value="index">{{view}}</option>
								</select>
						</div>
				</div>

		</div>
	</div>

</template>

<script>
/**
 * 응답내장형 문항 INPUT/SELECT 컴포넌트(fill in the blank question INPUT/SELECT component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import {MDCSelect} from '@material/select'

export default {
	props: ['data', 'itemIndex', 'setedAnswer'],

	data() {
		return {
			text: this.setedAnswer
		}
	},

	watch: {
		text: function(value) {
			this.setAnswer()
		},
	},

	mounted() {
		this.text = this.setedAnswer

		if(this.data.type === 'INPUT') {
      let textFields = [];
      for (const textField of document.querySelectorAll('.mdc-text-field')) {
        textFields.push(new MDCTextField(textField));
      }
      textFields.forEach(textField => textField.value = this.text);
		}
		if (this.data.type === 'SELECT') {
			const select = new MDCSelect(document.querySelector('.mdc-select'))
		}
	},

	methods: {
		// 정답 입력시 부모 컴포넌트에 전달(When entering the correct answer, it is delivered to the parent component)
		answerType(){
      this.setAnswer()
    },

		setAnswer() {
			this.currentQuestionCheckTrueFalse()
      this.checkIsChecked()
		},

		currentQuestionCheckTrueFalse() {
      this.$emit('checkCurrentQuestionStatus')
    },

    checkIsChecked() {
      let params = {
        index: this.itemIndex,
        text: this.text
      }
      this.$emit('setAnswer', params);
      this.$emit('checkIsCheckeds', params)
    },

		// v-model 제거 후 @input으로 변경
		updateText(e) {
				this.text = e.target.value;
		}
	}
}
</script>

<style scoped>
.mdc-floating-label .mdc-floating-label--float-above {
  width: auto;
}
</style>